import './styles.css'

angular.module(module.exports = 'ttb.dashboard', [
    require('./remaining-days'),
    require('./completed-story-points'),
    require('./completed-tasks-and-bugs'),
    require('./burn-down-diagram'),
    require('./burn-down-statuses-diagram'),
    require('./user-story-statuses'),
    require('./user-story-statuses-project'),
    require('./latest-activity-grid'),
    require('./priority-diagramm-project'),
    require('./dashboard-page'),
    'ttb.helpers',
    'ttb.core' // core bundle is always included on the page, requiring it here would duplicate it in this bundle
]);




// WEBPACK FOOTER //
// ./components/index.js